module.exports = __webpack_public_path__ + "static/ru-2-03e7ce1e28ee3309d1bb88224893d12e.png";